'use client'

import { useEffect, useState } from 'react'
import { Join } from '../../lib/utils'

export default function MediaQueryHelper({
  classNames,
}: {
  classNames?: string
}) {
  const [size, setSize] = useState({ w: 0, h: 0 })

  useEffect(() => {
    const update = () =>
      setSize({ w: window.innerWidth, h: window.innerHeight })
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  const dims = size.w > 0 ? ` ${size.w}×${size.h}` : ''

  return (
    <div
      className={Join(
        classNames,
        'fixed bottom-[-4px] left-0 z-[999] flex h-8 items-center rounded-tr-lg bg-black/70 px-3 text-white opacity-80',
      )}
    >
      <span className="text-xs sm:hidden">xsm{dims}</span>
      <span className="hidden text-xs sm:inline md:hidden">sm{dims}</span>
      <span className="hidden text-xs md:inline lg:hidden">md{dims}</span>
      <span className="hidden text-xs lg:inline xl:hidden">lg{dims}</span>
      <span className="hidden text-xs xl:inline 2xl:hidden">xl{dims}</span>
      <span className="hidden text-xs 2xl:inline">2xl{dims}</span>
    </div>
  )
}
